<template>

    <div>

        <!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <!-- page-heading -->
            <page-heading :show="true" pageTitle="CATALOG-HEADER-SETTINGS"></page-heading>

            <div class="columns">

                <div class="col-main">

    				<!-- FILTER BAR -->
                    <div class="box">
                        <div class="boxTitle">
                            <lang labelKey="CATALOG-SETTINGS-SECTION-VOUCHERS"></lang>
                        </div>

                        <form-input label="CATALOG-SETTINGS-NAME" inputType="text" v-model="catalogData.name"></form-input>

                        <div class="control">
                            <div class="control-label">
                                <label-name labelKey="CATALOG-SETTINGS-EXPIRATION_DATE"></label-name>
                            </div>
                            <div class="control">
                                <datepicker placeholder="Startdatum wählen" :options="datePickerOptions" v-model="catalogData.expirationDate"></datepicker>
                            </div>
                        </div>

                    </div>


                </div>

                <div class="col-aside">

                    <affix :offset="50">
          						<!-- SAVE BTN -->
          						<custom-button type="blue" icon="icon-ak-speichern" name="SITE_BUTTON_SAVE" :loading="isSaving" @click.native="save"></custom-button>

                    </affix>

                </div>

            </div>

        </template>

    </div>

</template>

<script>
import { de } from 'flatpickr/dist/l10n/de';
de.firstDayOfWeek = 1; // Monday

export default {


	data() {

		return {
            isLoading: false,
            isSaving: false,
            catalogData: null,

            datePickerOptions: {
                enableTime: true,
                enableSeconds: false,
                altInput: true,
                altFormat: 'd. F Y  - H:i',
                time_24hr: true,
                locale: de,
                clickOpens: true,
                weekNumbers: true
            },
        }
    },


    created() {

        this.fetchData();

    },

    methods: {


        fetchData() {
            this.isLoading = true;

            this.axios.get(this.$config.api + 'catalogProductVoucherExpirationDate?filters[catalog.isActive]=1&include=catalogProductVoucherExpirationDate.catalog').then(res => {
                this.catalogData = res.data.catalogProductVoucherExpirationDate[0]
                this.isLoading = false;
            })

        },

        save() {

            this.isSaving =  true;

            this.axios.put(this.$config.api + 'catalogProductVoucherExpirationDate/'+this.catalogData.id, this.catalogData).then(res => {

                this.$notify.open({ content: 'Erfolgreich gespeichert!', type: 'success' });
                this.isSaving = false;

            })

        }

    }

}
</script>

<style lang="scss" scoped >

    .box {
        .boxTitle {
            font-size: 20px;
            margin-bottom: 32px;
        }
    }
</style>
